export function createCookie(name, value, days, domain) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = '; expires=' + date.toGMTString();
  } else {
    var expires = '';
  }
  document.cookie =
    name + '=' + value + expires + '; domain=' + domain + '; path=/';
}
export function eraseCookie(name, domain) {
  createCookie(name, '', -1, domain);
}
